export const UI_COPY = {
  navigation: {
    backToMenu: 'Menu',
    help: 'Help',
  },
  editor: {
    buildTrack: 'Build Track',
    editPiece: 'Edit Piece',
    editShape: 'Edit Shape',
    rideCheck: 'Ride Check',
    rideSummary: 'Ride Summary',
    jumpToTrack: 'Jump to Track',
    ready: 'Ready to Ride',
    saveDraft: 'Save Draft',
    testRide: 'Test Ride',
    publish: 'Publish',
  },
  publish: {
    title: 'Publish Your Coaster',
    previewTitle: 'Coaster Preview Image',
    previewDescription: 'Players see this image while browsing coasters.',
    capturePreview: 'Capture Preview Image',
    replacePreview: 'Replace Preview',
    autoFrame: 'Auto-Frame',
    autoFrameAgain: 'Auto-Frame Again',
    createPrivateLink: 'Create Private Link',
    saveGateTitle: 'Save this coaster first',
    saveGateDescription: 'Save your draft before publishing.',
    saveAndContinue: 'Save Draft & Continue',
    keepEditing: 'Keep Editing',
  },
  media: {
    title: 'Share Your Ride',
    photo: 'Photo',
    video: 'Video',
    previewImage: 'Preview Image',
    shortLoop: 'Short Loop',
    enableCamera: 'Enable Camera',
  },
} as const;
